import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { IProduct } from '../../dashboard/services/account-overview.service';
import { AB_API_FULL_PORTFOLIO_VIEW } from '../constants';
import { ApiClientService } from './api-client.service';

@Injectable({
  providedIn: 'root'
})
export class FullPortfolioViewService extends ApiClientService {
  public bankAccounts = new ReplaySubject<any>();
  public accountsResponse: IProduct[] = undefined;
  private isLoading = false;

  constructor(http: HttpClient) {
    super(http, AB_API_FULL_PORTFOLIO_VIEW);
  }

  clearBankAccounts() {
    this.bankAccounts.complete();
    this.bankAccounts = new ReplaySubject<any>(null);
    this.accountsResponse = undefined;
  }

  getFullPortfolioView() {
    if (this.accountsResponse) {
      return this.bankAccounts.asObservable();
    }
    if (!this.isLoading && !this.accountsResponse) {
      this.isLoading = true;
      this.get().subscribe(
        response => {
          this.isLoading = false;
          this.bankAccounts.next({ bankAccounts: response.bankAccounts });
          this.accountsResponse = response.bankAccounts;
        },
        () => {
          this.isLoading = false;
          this.bankAccounts.next({ bankAccounts: [] });
        },
        () => {
          this.isLoading = false;
        }
      );
    }
    return this.bankAccounts.asObservable();
  }
}
